/* eslint-disable max-len */
import React from 'react';

const BoldIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M11.5 14H7v-3h4.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5zM7 6h3.5c.827 0 1.5.673 1.5 1.5S11.327 9 10.5 9H7V6zm6.337 3.534C13.75 8.959 14 8.26 14 7.5 14 5.57 12.43 4 10.5 4H5v12h6.5c1.93 0 3.5-1.57 3.5-3.5 0-1.254-.669-2.348-1.663-2.966z"
            transform="translate(-83.000000, -81.000000) translate(78.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default BoldIcon;
